import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const add_add_ons = createAsyncThunk(
  "addons/add_add_ons",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/addons/new`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("product Not create");
    }
  }
);

export const get_restaurant_add_ons = createAsyncThunk(
  "addons/get_restaurant_add_ons",
  async (restaurantID, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/addons/restaurant-addons/${restaurantID}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);

const initialState = {
  add_ons_all: JSON.parse(localStorage.getItem("add_ons_all"))
    ? JSON.parse(localStorage.getItem("add_ons_all"))
    : [],
  add_ons_allLoading: true,
  isadd_ons_allAvailable: localStorage.getItem("add_ons_all") ? true : false,
};

const AddonsSlice = createSlice({
  name: "addons",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(get_restaurant_add_ons.pending, (state) => {
        state.add_ons_allLoading = true;
      })
      .addCase(get_restaurant_add_ons.fulfilled, (state, action) => {
        state.add_ons_all = action.payload.addons;
        state.add_ons_all = state.add_ons_all;
        localStorage.setItem("add_ons_all", JSON.stringify(state.add_ons_all));
        state.add_ons_allLoading = false;
        state.isadd_ons_allAvailable = true;
      })
      .addCase(get_restaurant_add_ons.rejected, (state) => {
        state.add_ons_allLoading = true;
      });
  },
});

export const {} = AddonsSlice.actions;
export const authActions = AddonsSlice.actions;
export default AddonsSlice.reducer;
